// 应用商城接口
import request from '@/utils/request'

// UEditor富文本配置接口
export function ueditorHandleUrl() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/ueditor/handle'
}

// 应用商城上传文件
export function uploadMerchantFile() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/uploadFile'
}

// 应用商城预览文件
export function previewMerchantFile() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/previewFile?fileRecordId='
}

// 应用商城删除文件
export const deleteMerchantFile = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/removeFile',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 附件查询列表
export const queryMerchantFileList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 应用商城查询字典
export const queryMerchantDictionary = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantDictionary/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询商品服务分类及项目
export const queryMerchantServiceCategoryWithItems = () => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantServiceCategory/selectServiceCategoryWithItems',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		}
	})
}

// 应用商城提交风采、宣传订单
export const submitMerchantOrder = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/submitOrder',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 应用商城查询风采、宣传订单列表
export const queryMerchantOrderList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前登录用户实际购买的商城订单
export const queryMyPurchaseOrderPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/myPurchaseOrderPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前登录用户发布商品时生成的订单
export const queryMyPublishedGoodsOrderPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/myPublishedGoodsOrderPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 应用商城查询风采、宣传订单详情
export const queryMerchantOrderDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询发货进度
export const queryMerchantOrderDeliveryProgress = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/getByIdLc',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询（企业宣传、企业风采）金额及活动价格（100 企业宣传；200 企业风采；300 宣传头条；400 风采头条）
export const queryMerchantOrderPrice = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/itemEventPromotion/mapBuyValueAddedServiceVO',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 提交开店申请或驳回后重新提交
export const submitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/submit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交店铺资料变更申请
export const changeSubmitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/changeSubmit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交闭店申请
export const closeSubmitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/closeSubmit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户店铺信息
export const queryMyShop = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShop/myShop',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询当前用户的店铺申请记录
export const queryMyShopApplyPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/myApplyPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前用户最新店铺申请
export const queryMyLatestShopApply = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/myLatestApply',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询店铺申请详情
export const queryMerchantShopApplyDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存商品草稿
export const saveMerchantGoodsDraft = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/saveDraft',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交商品上架
export const submitMerchantGoods = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/submit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询我的店铺商品分页
export const queryMyMerchantGoodsPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/myGoodsPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前服务商店铺商品的购买订单
export const queryMyShopGoodsOrderPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/myShopGoodsOrderPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询商品详情
export const queryMerchantGoodsDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询商城全部已上架商品
export const queryPublishedMerchantGoodsList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/listPublishedNotoken',
		method: 'get',
		isShowLoader: false,
		params
	})
}

// 查询门户商城已上架商品详情
export const queryPublishedMerchantGoodsDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/getPublishedByIdNotoken',
		method: 'get',
		isShowLoader: false,
		params
	})
}

// 模拟支付并提交商品订单，真实支付渠道接入后替换此接口
export const mockPayMerchantGoods = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/mockPay',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 创建商城待支付结算单，并按店铺生成业务订单
export const createMerchantCheckout = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/create',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询商城支付单及商品订单快照
export const queryMerchantCheckoutDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/detail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 选择或取消商城结算优惠券，由服务端重新计算实际应付金额
export const applyMerchantCheckoutCoupon = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/coupon',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 模拟支付已经生成的商城支付单
export const mockPayMerchantCheckout = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/mockPay',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 为商城支付单申请招行聚合收款码
export const applyCmbMerchantCheckout = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/cmbPay',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 主动查询招行聚合支付结果
export const queryCmbPayment = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/cmbPay/query',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 根据商城支付主单主动查询招行聚合支付结果
export const queryCmbPaymentByPaymentOrder = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/cmbPay/paymentOrder/query',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 取消商城支付单及其按店铺拆分的全部待支付订单
export const cancelMerchantCheckout = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCheckout/cancel',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 将平台自营商品加入当前用户购物车
export const addMerchantShoppingCart = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/add',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户购物车
export const queryMerchantShoppingCart = () => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		}
	})
}

// 修改购物车商品数量
export const updateMerchantShoppingCartQuantity = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/updateQuantity',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 修改购物车商品勾选状态
export const updateMerchantShoppingCartChecked = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/updateChecked',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 移出单个购物车商品
export const removeMerchantShoppingCart = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/remove',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 批量移出购物车商品
export const batchRemoveMerchantShoppingCart = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/batchRemove',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询购物车商品种类数量
export const queryMerchantShoppingCartCount = () => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/count',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		}
	})
}

// 购物车结算前按当前商品价格预览金额
export const previewMerchantShoppingCartSettlement = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShoppingCart/settlementPreview',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 修改商品状态
export const updateMerchantGoodsState = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/updateState',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户店铺下的已上架商品及已绑定权益
export const queryMyPublishedGoodsBenefitPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoodsBenefit/myPublishedPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询启用的商品权益基础配置
export const queryEnabledGoodsBenefits = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoodsBenefit/listEnabledBenefits',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前用户指定商品的权益快照
export const queryMyGoodsBenefits = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoodsBenefit/myGoodsBenefits',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存当前用户商品的权益配置
export const saveMyGoodsBenefitConfig = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoodsBenefit/saveMyConfig',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 当前登录服务商对本店铺商品订单发货，后端同步发放订单权益快照
export const providerShipMerchantOrder = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/providerShip',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户由已发货商品获得的权益订单
export const queryMyGoodsBenefitOrders = () => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/userGoodsBenefit/myOrderList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		}
	})
}

// 查询指定订单商品的权益明细和使用流水
export const queryMyGoodsBenefitDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/userGoodsBenefit/detail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
